/* script-offer.js */
/* ==========================================================
   INNOVA 5610 OFFER PAGE (index-offer.html)
   Built on Oct 14, 2026 as a rebuild of offer.innova.com/5610-a. The page's own sections (floating bar,
   feature panels, carousel, reviews window) are written here. The offer (the 2026 holiday gift bundle), the
   CarMD Connect section and window, the gift windows and the technical side are the switch page's code
   (script-switch.js) without its flash sale, popup, email code and InnovaCare+. The photo viewer and the
   accordions are the SD35 page's. It shares no file with the other pages.
   ========================================================== */
(function () {
  'use strict';

  var root = document.getElementById('o5') || document.body;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var playSafe = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };

  /* ---------- star ratings ----------
     data-stars is the value; data-color the filled colour; data-empty the colour of an empty star,
     or "outline" for an empty star drawn as an outline in the filled colour. */
  var STAR = 'M12 2.6l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.45 6.19 20.5 7.3 14.03 2.6 9.45l6.5-.95z';
  document.querySelectorAll('[data-stars]').forEach(function (el) {
    var v = parseFloat(el.getAttribute('data-stars')) || 5;
    var col = el.getAttribute('data-color') || '#f5a524';
    var empty = el.getAttribute('data-empty') || '#d5d9df';
    var line = empty === 'outline';
    var emptyFill = line ? 'none' : empty;
    var stroke = line ? ' stroke="' + col + '" stroke-width="1.6" stroke-linejoin="round"' : '';
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill = v >= i ? 1 : (v > i - 1 ? v - (i - 1) : 0);
      if (fill === 1) {
        html += '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR + '" fill="' + col + '"' + stroke + '/></svg>';
      } else if (fill === 0) {
        html += '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR + '" fill="' + emptyFill + '"' + stroke + '/></svg>';
      } else {
        var id = 'g' + Math.random().toString(36).slice(2, 8);
        html += '<svg viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="' + id + '">' +
          '<stop offset="' + (fill * 100) + '%" stop-color="' + col + '"/>' +
          '<stop offset="' + (fill * 100) + '%" stop-color="' + (line ? '#fff' : empty) + '" stop-opacity="' + (line ? 0 : 1) + '"/></linearGradient></defs>' +
          '<path d="' + STAR + '" fill="url(#' + id + ')"' + stroke + '/></svg>';
      }
    }
    el.innerHTML = html;
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', v + ' out of 5 stars');
  });

  /* ---------- sections rise into place the first time they come on screen ----------
     Anything already on screen is marked at once, in the same step, so nothing on the first screen
     blinks out and back. Without IntersectionObserver everything simply shows. */
  (function () {
    var secs = [].slice.call(document.querySelectorAll('.rv'));
    if (!secs.length || still || !('IntersectionObserver' in window)) return;
    root.classList.add('rv-on');
    var h = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    secs.forEach(function (s) {
      if (s.getBoundingClientRect().top < h) s.classList.add('in');
      else io.observe(s);
    });
  })();

  /* ---------- top bar: countdown to midnight (the visitor's own clock), in three boxes as in the mockup ---------- */
  var tbarH = document.getElementById('tbarH'), tbarM = document.getElementById('tbarM'), tbarS = document.getElementById('tbarS');
  if (tbarH && tbarM && tbarS) {
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var now = new Date(), end = null;
      // during a flash sale (see "the flash sale" below) the boxes count down to the sale's end, the sheet's End (Pacific),
      // and at that moment the page goes back to the gift bundle; otherwise they count down to the visitor's midnight
      if (promo && promo.end && now.getTime() >= promo.end) endFlash();
      if (saleActive && promo && promo.end) end = new Date(promo.end);
      if (!end) { end = new Date(now); end.setHours(24, 0, 0, 0); }
      var d = Math.max(0, end - now);
      tbarH.textContent = pad(Math.floor(d / 3600000));
      tbarM.textContent = pad(Math.floor((d % 3600000) / 60000));
      tbarS.textContent = pad(Math.floor((d % 60000) / 1000));
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- floating bar: shows once the visitor is 600px down the page, except in the offer ----------
     A marker 600px from the top is watched instead of window.scrollY, because on Shopify the theme
     makes <body> the scroller and window.scrollY stays at 0. While any of the offer (#buy) is on screen
     the bar stays away (the user, Oct 14 2026: "the sticky shop now button should be hidden when the user
     is in the offer section"): the offer has its own Claim Offer buttons. */
  var fbar = document.getElementById('fbar');
  if (fbar) {
    var fbCta = fbar.querySelector('.fbar-cta'), pastTop = false, inOffer = false;
    var setBar = function () {
      var on = pastTop && !inOffer;
      fbar.classList.toggle('on', on);
      fbar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (fbCta) fbCta.setAttribute('tabindex', on ? '0' : '-1');
    };
    if ('IntersectionObserver' in window) {
      if (getComputedStyle(root).position === 'static') root.style.position = 'relative';
      var mark = document.createElement('div');
      mark.setAttribute('aria-hidden', 'true');
      mark.style.cssText = 'position:absolute;top:600px;left:0;width:1px;height:1px;pointer-events:none';
      root.appendChild(mark);
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { pastTop = !en.isIntersecting && en.boundingClientRect.top < 0; });
        setBar();
      }).observe(mark);
      var offerSec = document.getElementById('buy');
      if (offerSec) new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { inOffer = en.isIntersecting; });
        setBar();
      }).observe(offerSec);
    } else { pastTop = true; setBar(); }
  }

  /* ---------- windows: product overview video, customer reviews ---------- */
  var anyOpen = function () { return !!document.querySelector('.ovm.open, .rvm.open, .modal.open, .lbx.open, .cart.open'); };
  function wireWindow(box, openBtns, closeSel, onOpen, onClose) {
    if (!box) return null;
    var lastFocus = null;
    var open = function () {
      lastFocus = document.activeElement;
      box.classList.add('open');
      box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      if (onOpen) onOpen();
      var x = box.querySelector('button' + closeSel);
      if (x && x.focus) x.focus();
    };
    var close = function () {
      box.classList.remove('open');
      box.setAttribute('aria-hidden', 'true');
      if (onClose) onClose();
      if (!anyOpen()) document.body.classList.remove('modal-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    [].forEach.call(openBtns, function (b) { if (b) b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    box.querySelectorAll(closeSel).forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('open')) close(); });
    return { open: open, close: close };
  }
  var ovVideo = document.getElementById('ovVideo');
  wireWindow(document.getElementById('ovModal'), document.querySelectorAll('.js-overview'), '[data-ov-close]',
    function () {
      if (!ovVideo) return;
      if (!ovVideo.getAttribute('src')) ovVideo.setAttribute('src', ovVideo.getAttribute('data-src'));
      playSafe(ovVideo);
    },
    function () { if (ovVideo && !ovVideo.paused) ovVideo.pause(); });
  wireWindow(document.getElementById('rvModal'), document.querySelectorAll('.js-reviews'), '[data-rv-close]');

  /* ---------- real mechanics: on a phone a swipe row, with dots that follow it ---------- */
  var mechRow = document.getElementById('mechRow'), mechDots = document.getElementById('mechDots');
  if (mechRow && mechDots) {
    var dotBtns = [].slice.call(mechDots.querySelectorAll('button'));
    var cardsM = [].slice.call(mechRow.children);
    var markDot = function () {
      var w = mechRow.clientWidth || 1;
      var n = Math.min(cardsM.length - 1, Math.max(0, Math.round(mechRow.scrollLeft / w)));
      dotBtns.forEach(function (d, i) { d.classList.toggle('on', i === n); });
    };
    mechRow.addEventListener('scroll', markDot, { passive: true });
    dotBtns.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var c = cardsM[i];
        if (c) mechRow.scrollTo({ left: c.offsetLeft - mechRow.offsetLeft - parseFloat(getComputedStyle(mechRow).paddingLeft || 0), behavior: still ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- stuffed with features: one panel open at a time, its video beside it ----------
     The videos load nothing until the section comes on screen, and only the open panel's plays. */
  (function () {
    var list = document.getElementById('stfList'), media = document.getElementById('stfMedia');
    if (!list || !media) return;
    var items = [].slice.call(list.querySelectorAll('.stf-it'));
    var vids = [].slice.call(media.querySelectorAll('video'));
    var at = 0, inView = false;
    var sync = function () {
      vids.forEach(function (v, i) {
        v.classList.toggle('on', i === at);
        if (i === at && inView && !still) { if (v.preload === 'none') v.preload = 'auto'; playSafe(v); }
        else if (!v.paused) v.pause();
      });
      if (still && vids[at] && vids[at].preload === 'none' && inView) vids[at].preload = 'metadata';
    };
    items.forEach(function (it, i) {
      it.querySelector('.stf-q').addEventListener('click', function () {
        if (i === at) return;   // one always open, as on the offer page
        at = i;
        items.forEach(function (x, k) {
          x.classList.toggle('open', k === i);
          x.querySelector('.stf-q').setAttribute('aria-expanded', k === i ? 'true' : 'false');
        });
        sync();
      });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; sync(); }, { threshold: 0.2 }).observe(media);
    } else { inView = true; sync(); }
  })();

  /* ---------- ASE-verified fixes: the carousel ----------
     The slide in front is full size; its two neighbours sit 400px either side at half size and faded;
     the rest are hidden. Arrows, a click on a neighbour, a swipe or the arrow keys (on the stage) move it. */
  (function () {
    var stage = document.getElementById('aseStage'), info = document.getElementById('aseInfo');
    if (!stage || !info) return;
    var slides = [].slice.call(stage.querySelectorAll('.ase-sl'));
    var texts = [].slice.call(info.querySelectorAll('.ase-txt'));
    var n = slides.length, at = 0;
    var place = function () {
      slides.forEach(function (s, i) {
        var m = i - at;
        if (m > n / 2) m -= n;
        if (m < -n / 2) m += n;
        var front = m === 0;
        s.style.transform = 'translateX(' + (m * 400) + 'px) scale(' + (front ? 1 : 0.5) + ')';
        s.style.opacity = front ? '1' : '0.35';
        s.style.zIndex = front ? '10' : String(5 - Math.abs(m));
        s.classList.toggle('on', front);
        s.classList.toggle('far', Math.abs(m) > 1);
        s.setAttribute('aria-hidden', front ? 'false' : 'true');
      });
      texts.forEach(function (t, i) { t.classList.toggle('on', i === at); });
    };
    var go = function (i) { at = (i + n) % n; place(); };
    slides.forEach(function (s, i) { s.addEventListener('click', function () { if (i !== at) go(i); }); });
    var prev = document.getElementById('asePrev'), next = document.getElementById('aseNext');
    if (prev) prev.addEventListener('click', function () { go(at - 1); });
    if (next) next.addEventListener('click', function () { go(at + 1); });
    var x0 = null, x1 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; x1 = null; }, { passive: true });
    stage.addEventListener('touchmove', function (e) { x1 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function () {
      if (x0 !== null && x1 !== null) {
        var d = x0 - x1;
        if (d > 50) go(at + 1); else if (d < -50) go(at - 1);
      }
      x0 = x1 = null;
    });
    place();

    /* the workshop tools list under "Workshop Tools" */
    var ws = document.getElementById('ws');
    if (ws) {
      var q = ws.querySelector('.ws-q'), a = ws.querySelector('.ws-a');
      q.addEventListener('click', function () {
        var on = !ws.classList.contains('open');
        ws.classList.toggle('open', on);
        q.setAttribute('aria-expanded', on ? 'true' : 'false');
        a.hidden = !on;
      });
    }
  })();

  /* ==========================================================
     THE OFFER: the partnerships pages' 2026 holiday offer (the user's request, Oct 14, 2026: "keep the
     same as the partnerships"). The phases, gifts, codes, stock check and cart links below are Variant D's
     and the switch page's (script-switch.js), without the flash sale, the scratch-card popup, the email
     code and InnovaCare+. A change to the offer there does not reach this page by itself: copy it here.
     From 12:01 AM Pacific on Oct 8 until the end of Dec 31 the visitor picks ONE free gift, plus a $20
     Innova gift card; outside that window the bundle is the everyday one with the 3360 camera.
     Preview any phase with ?phase=prebf|bf|cm|xmas (or ?phase=off), preselect with ?gift=3360|3380|carmd,
     pretend gifts are sold out with ?soldout=3360,carmd.
     ========================================================== */
  var setHTML = function (id, html) { var el = document.getElementById(id); if (el) el.innerHTML = html; };
  var HOLIDAY_PHASES = [
    // The user, Nov 2 2026: "start the black friday starting Nov 6 till CM, then CM change to CM, and then change to Christmas.
    // automatically". Cyber Monday 2026 is Nov 30 (it was set to Dec 1, last year's date). carmd: CarMD Connect can be the
    // gift, before Nov 6 only ("After Nov 6, kill all CarMD offers and mentions"). gift: the one picked at first, the 3360
    // ("keep the price at $349 with the freebie (3360) selected"), the 3380 while the 3360 is sold out.
    { key: 'prebf', from: '2026-10-08 00:01', to: '2026-11-06 00:00', lead: 'PRE-BLACK FRIDAY', badge: 'Pre-Black Friday', pick: 'Your Pre-Black Friday gift: pick one', carmd: true },
    { key: 'bf',    from: '2026-11-06 00:00', to: '2026-11-30 00:00', lead: 'BLACK FRIDAY',     badge: 'Black Friday',     pick: 'Your Black Friday gift: pick one', gift: '3360' },
    { key: 'cm',    from: '2026-11-30 00:00', to: '2026-12-01 00:00', lead: 'CYBER MONDAY',     badge: 'Cyber Monday',     pick: 'Your Cyber Monday gift: pick one', gift: '3360' },
    { key: 'xmas',  from: '2026-12-01 00:00', to: '2027-01-01 00:00', lead: 'CHRISTMAS SALE',   badge: 'Christmas Sale',   pick: 'Your Christmas gift: pick one', gift: '3360' }
  ];
  /* qty: how many of the gift go in the cart (1 if not given); freebies: the code that frees the boot, app,
     shipping and gift card alongside this gift's own code (HOLIDAY_FREEBIES_CODE if not given).
     CarMD Connect comes as two from Oct 23, 2026 (the user: "update the offer so that it gives 2 CarMD
     dongles"), with the user's own link and codes: 5610_BOGO_2CarMD frees both, 5610DEAL0 the rest. */
  var GIFTS = {
    // the picker's order: CarMD Connect first, and the default pick (the user's call for the partnerships pages, Oct 13 2026)
    'carmd': { variant: '42744886525998', qty: 2, code: '5610_BOGO_2CarMD', freebies: '5610DEAL0', value: 200, name: '2\u00d7 CarMD Connect', cartName: 'CarMD Connect \u00d72' },
    '3360':  { variant: '39553005617198', code: '5610_BOGO3360_PARTNER', value: 200, name: 'Innova 3360 Thermal Camera',    cartName: 'Innova 3360 Camera' },
    '3380':  { variant: '32538802585646', code: '5610_BOGO3380',         value: 99,  name: 'Innova 3380 Inspection Camera', cartName: 'Innova 3380 Camera' }
  };
  // a line under each gift's name in the bundle list (the gift windows' own words)
  var GIFT_SUBS = { 'carmd': 'Two car health monitors + app', '3360': 'Sees heat from up to 100 feet', '3380': 'A camera on a 39-inch probe' };
  // Shopify product handles, for the live stock check
  var GIFT_HANDLES = { '3360': 'innova-multi-purpose-infrared-inspection-camera-3360', '3380': '3380-inspection-camera', 'carmd': 'carmd-connect' };
  var GIFT_CARD_VARIANT = '41613976174638', GIFT_CARD_VALUE = 20, BUNDLE_PRICE = 349;   // $20 Innova Digital Gift Card
  /* ---------- the email price (the user, Oct 26 2026) ----------
     Until the end of Nov 1, 2026 (Pacific), a visitor who gives their email in the box above Claim Offer gets the
     5610 for $299: every price on the page drops by $50 and every cart link carries code, a $50 order discount made
     in Shopify for this. The email goes to the Klaviyo list below. The address is kept in this browser, so the price
     holds on a return visit; after the end the box goes and everything is as before, for those who signed up too.
     Preview: ?maildeal=on (even after the end) or ?maildeal=off. */
  var MAIL_DEAL = { until: '2026-11-02 00:00', price: 299, code: '5610_EMAIL_299', klaviyoKey: 'T9Ldwz', list: 'W4KGjy', store: 'innova_bundle_email_299' };
  // "YYYY-MM-DD HH:MM" in Pacific time, now or at the time given (ms)
  var pacificNow = function (at) {
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(at ? new Date(at) : new Date())
        .forEach(function (x) { g[x.type] = x.value; });
      return g.year + '-' + g.month + '-' + g.day + ' ' + (g.hour === '24' ? '00' : g.hour) + ':' + g.minute;
    } catch (e) { return null; }
  };
  var mailOpen = (function () {
    var forced = (location.search.match(/[?&]maildeal=(on|off|done)\b/) || [])[1];
    if (forced === 'done') forced = 'on';
    if (forced) return forced === 'on';
    var now = pacificNow();
    return !!now && now < MAIL_DEAL.until;
  })();
  var mailEmail = null;
  if (mailOpen) { try { mailEmail = localStorage.getItem(MAIL_DEAL.store); } catch (e) {} }
  if (/[?&]maildeal=done\b/.test(location.search)) { mailOpen = true; mailEmail = 'preview'; }   // the unlocked look, nothing sent or kept
  /* a flash sale from the sale sheet (see "the flash sale" below): promo is the sheet's row while one runs, saleActive
     whether its deal is the one on show. The email price never stacks on it. */
  var promo = null, saleActive = false;
  var mailOn = function () { return mailOpen && !!mailEmail && !saleActive; };
  var price = function () { return saleActive ? promo.price : dropOn ? PRICE_DROP.price : mailOn() ? MAIL_DEAL.price : BUNDLE_PRICE; };
  var offStr = function () { return '$' + (MSRP - price()); };          // "$200" off the scanner, "$250" with the email price
  // the $299 week's code (PRICE_DROP, below) or an unlocked email price's; never both (they are the same code)
  var withMailCode = function (url) {
    var code = dropOn ? PRICE_DROP.code : mailOn() ? MAIL_DEAL.code : '';
    return code ? url + (url.indexOf('?') < 0 ? '?discount=' : ',') + code : url;
  };
  var MSRP = 549, F_CAM = 200, F_BOOT = 20, F_APP = 99, F_SHIP = 10;
  /* In the holiday links 5610_PARTNERSHIPS_GIFTCARD takes the place of 5610_PARTNERSHIPS_FP: the same free
     boot, app and shipping, plus the $20 gift card, in one code that stacks with each gift's own code. */
  var HOLIDAY_FREEBIES_CODE = '5610_PARTNERSHIPS_GIFTCARD';
  var BUNDLE_ITEMS = '32524554436654:1,41990059687982:1,41968968794158:1,41990063915054:1';  // 5610, boot, shipping, app
  var CART_BASE = 'https://www.innova.com/cart/' + BUNDLE_ITEMS + ',39553005617198:1?discount=5610_BOGO3360_PARTNER,5610_PARTNERSHIPS_FP';
  var holiday = (function () {
    var forced = (location.search.match(/[?&]phase=([a-z]+)/) || [])[1];
    if (forced === 'off') return null;
    var i, now;
    for (i = 0; i < HOLIDAY_PHASES.length; i++) if (HOLIDAY_PHASES[i].key === forced) return HOLIDAY_PHASES[i];
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date())
        .forEach(function (x) { g[x.type] = x.value; });
      now = g.year + '-' + g.month + '-' + g.day + ' ' + (g.hour === '24' ? '00' : g.hour) + ':' + g.minute;
    } catch (e) { return null; }
    for (i = 0; i < HOLIDAY_PHASES.length; i++) {
      if (HOLIDAY_PHASES[i].from <= now && now < HOLIDAY_PHASES[i].to) return HOLIDAY_PHASES[i];
    }
    return null;
  })();
  /* CarMD Connect is a gift only before Nov 6 (holiday.carmd, above). From then on it leaves GIFTS, so the picker, the stock
     check, the links and everything that names the picked gift go without it; its card leaves the picker and the page
     carries no-carmd (no CarMD Connect section). */
  var carmdOn = !!holiday && !!holiday.carmd;
  if (!carmdOn) delete GIFTS.carmd;
  var giftKey = (location.search.match(/[?&]gift=(3360|3380|carmd)\b/) || [])[1];
  if (!GIFTS[giftKey]) giftKey = (holiday && holiday.gift) || (carmdOn ? 'carmd' : '3360');
  /* ---------- Black Friday week at $299 (the user, Nov 2 2026: "From Nov 26-30, still offer the freebie but drop the price
     to $299") ----------
     From 12:00 AM Pacific on Nov 26 to the end of Nov 30 the gift bundle costs $299 for everyone: every price on the page
     reads $299 and every gift link carries code, a $50 order discount (5610_EMAIL_299, made for the email price; it combines
     with the gift codes, and Shopify has to keep it valid until Nov 30 11:59 PM). A flash sale still leads with
     its own price. Preview: ?pricedrop=on|off. */
  var PRICE_DROP = { from: '2026-11-26 00:00', to: '2026-12-01 00:00', price: 299, code: '5610_EMAIL_299' };
  var dropOn = !!holiday && (function () {
    var forced = (location.search.match(/[?&]pricedrop=(on|off)\b/) || [])[1];
    if (forced) return forced === 'on';
    var now = pacificNow();
    return !!now && PRICE_DROP.from <= now && now < PRICE_DROP.to;
  })();
  if (dropOn) root.classList.add('drop-on');     // hides Shop Pay's installments line, worked out from $349.99
  var noCamera = false;   // everyday offer only: true once Shopify says the 3360 is sold out
  /* Ask Shopify's public product JSON whether each gift's variant is still for sale. It answers any origin,
     so this also works on Railway. done(avail) gets avail[key] === false for a sold-out gift; a failed or
     slow check (5s) leaves the key unset, which counts as in stock, so a hiccup can never blank the offer. */
  var checkStock = function (keys, done) {
    if (!window.fetch) return;
    var avail = {}, pending = keys.length;
    var forced = ((location.search.match(/[?&]soldout=([a-z0-9,]+)/) || [])[1] || '').split(',');
    var base = /(^|\.)innova\.com$/.test(location.hostname) ? '' : 'https://www.innova.com';
    var settle = function () { if (!--pending) done(avail); };
    keys.forEach(function (k) {
      if (forced.indexOf(k) > -1) { avail[k] = false; settle(); return; }
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 5000);
      fetch(base + '/products/' + GIFT_HANDLES[k] + '.js', { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          var v = p.variants.filter(function (x) { return String(x.id) === GIFTS[k].variant; })[0];
          avail[k] = v ? !!v.available : !!p.available;
        })
        .catch(function () {})
        .then(function () { clearTimeout(timer); settle(); });
    });
  };
  /* the cart link for the bundle as it stands: the picked gift + the gift card with that gift's own code
     during the holiday window, the everyday camera bundle otherwise */
  var bundleCart = function () {
    if (!holiday) return withMailCode(noCamera ? 'https://www.innova.com/cart/' + BUNDLE_ITEMS + '?discount=5610_PARTNERSHIPS_FP' : CART_BASE);
    var g = giftKey ? GIFTS[giftKey] : null;    // null only if every gift is sold out: gift card only
    return withMailCode('https://www.innova.com/cart/' + BUNDLE_ITEMS + (g ? ',' + g.variant + ':' + (g.qty || 1) : '') + ',' + GIFT_CARD_VARIANT + ':1' +
      '?discount=' + (g ? g.code + ',' : '') + ((g && g.freebies) || HOLIDAY_FREEBIES_CODE));
  };
  var cartGo = document.getElementById('cartGo');
  /* Other apps can add their own parameters to our cart links after the page loads: Intelligems appends
     attributes[igId]=... so the order is credited to the visitor's test group. Every rewrite (a gift pick)
     would wipe it, so carry over anything that isn't ours (discount, payment) from the link being replaced. */
  var keepExtras = function (oldHref, url) {
    var q = (oldHref && oldHref.indexOf('/cart/') > -1 && oldHref.split('?')[1]) || '';
    var extras = q.split('&').filter(function (p) { return p && !/^(discount|payment)=/i.test(p); });
    return extras.length ? url + (url.indexOf('?') < 0 ? '?' : '&') + extras.join('&') : url;
  };
  var setCheckout = function (url) {
    document.querySelectorAll('.js-checkout').forEach(function (a) { if (a.tagName === 'A') a.setAttribute('href', keepExtras(a.getAttribute('href'), url)); });
    if (cartGo) cartGo.setAttribute('href', keepExtras(cartGo.getAttribute('href'), url));
    var n = 0;
    document.querySelectorAll('.cart-body .citem').forEach(function (el) { if (getComputedStyle(el).display !== 'none') n++; });
    setHTML('cartCount', n + ' item' + (n === 1 ? '' : 's'));
  };

  /* ---------- Shop Pay Installments window: check out with the whole bundle ----------
     Shopify's "Continue to checkout" button builds /cart/<5610 variant>:1 by itself, so the gift, the gift
     card and the codes would drop off. Catch the click before Shopify's own handler runs and send it to the
     same cart link the rest of the page uses. The window lives in an open shadow root, which composedPath()
     can see into. If Shopify ever renames the hook, nothing matches and theirs runs. */
  window.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var hit = path.some(function (n) {
      return n && n.getAttribute && n.getAttribute('data-testid') === 'sample-plans-modal-continue-to-checkout-button';
    });
    if (!hit || !cartGo) return;
    var url = cartGo.getAttribute('href');
    if (!url || url === '#') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = url + (url.indexOf('?') < 0 ? '?' : '&') + 'payment=shop_pay_installments';
  }, true);

  /* ---------- the offer's photo gallery ----------
     The first photo is the bundle shot with the two tech callouts; the thumbnails mark the frame .is-alt
     on any other photo, which hides the callouts. Outside the holiday window that shot (CarMD Connect and
     the gift card are in it) is taken out, and the gallery opens on Variant D's first photo. */
  var thumbs = document.getElementById('galThumbs'), galMain = document.getElementById('galMain');
  var galFrame = galMain && galMain.parentNode;
  if (!holiday) root.classList.add('no-holiday');
  if (thumbs && galMain) {
    if (!holiday) {
      var firstThumb = thumbs.querySelector('button');
      if (firstThumb && thumbs.children.length > 1) {
        firstThumb.parentNode.removeChild(firstThumb);
        var nextThumb = thumbs.querySelector('button');
        nextThumb.classList.add('on');
        galMain.src = nextThumb.getAttribute('data-src');
        galMain.alt = 'Innova 5610';
      }
    }
    [].forEach.call(thumbs.querySelectorAll('button'), function (b, i) {
      b.addEventListener('click', function () {
        thumbs.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        galMain.src = b.getAttribute('data-src');
        if (galFrame) galFrame.classList.toggle('is-alt', i !== 0 || !holiday);
      });
    });
  }

  /* ---------- the bundle shots follow the picked gift ----------
     The user, Oct 14 2026: when the visitor picks the 3360 or 3380, the offer photo shows that gift. The
     hero photo and the offer's first photo (and its thumbnail) carry one version per gift in data-gift-*
     attributes, so the Shopify build rewrites their addresses like any other photo; "none" is the one with
     no gift, for when every gift is sold out. The offer's photo changes on screen only while it is the one
     on show; otherwise the thumbnail takes the new version for later. */
  var hxPhoto = document.getElementById('hxPhoto'), giftThumb = document.getElementById('galGiftThumb');
  var GIFT_ALT = { carmd: 'two CarMD Connect devices', '3360': 'the 3360 Thermal Camera', '3380': 'the 3380 Inspection Camera' };
  var giftPhotos = function (key) {
    var k = key || 'none', withGift = GIFT_ALT[key] ? ' with ' + GIFT_ALT[key] + ' and' : ' with';
    var card = k === 'flash' ? '' : withGift + ' an Innova gift card';     // "flash": the 5610 alone, for the flash deal
    var hv = hxPhoto && hxPhoto.getAttribute('data-gift-' + k);
    if (hv && hxPhoto.getAttribute('src') !== hv) {
      hxPhoto.setAttribute('src', hv);
      hxPhoto.alt = 'Innova 5610 scanner' + (card && card + ' included in the bundle');
    }
    if (!holiday || !giftThumb || !giftThumb.parentNode || !giftThumb.getAttribute('data-gift-' + k)) return;
    var src = giftThumb.getAttribute('data-gift-' + k);
    giftThumb.setAttribute('data-src', src);
    var ti = giftThumb.querySelector('img'); if (ti) ti.setAttribute('src', src);
    if (giftThumb.classList.contains('on') && galMain) {
      galMain.setAttribute('src', src);
      galMain.alt = 'Innova 5610' + card;
    }
  };
  // load the gifts' versions of the offer photo once the gift picker is near, so a pick swaps at once
  var picksBox = document.getElementById('giftPicks');
  if (holiday && giftThumb && picksBox && 'IntersectionObserver' in window) {
    var preIO = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      preIO.disconnect();
      ['carmd', '3360', '3380'].forEach(function (k) { var im = new Image(); im.src = giftThumb.getAttribute('data-gift-' + k); });
    }, { rootMargin: '600px 0px' });
    preIO.observe(picksBox);
  }

  /* ---------- the tech callouts on the first photo ----------
     The picked gift's names that gift, sits on it in the photo (GIFT_SPOT, in % of the photo) and opens its
     window: CarMD Connect's the CarMD window (a copy of the CarMD Connect section, set up further down), the
     cameras' their Learn more windows. It hides when every gift is sold out. The gift card's opens and
     closes its note. Neither click goes on to the photo viewer. The hero's gift bubble works the same way. */
  /* [x %, y %, tag to the left of the circle]. The CarMD version is the user's photo (Oct 23, 2026) with the gift
     card on the left and the two dongles on the right; in the others the gift is on the left and the card on the
     right. CARD_SPOT.other is the card's place in those. */
  var GIFT_SPOT = { carmd: [70, 65], '3360': [19, 61], '3380': [23, 67] };
  var CARD_SPOT = { carmd: [34, 62, 1], other: [88, 66, 1] };
  var hxBubs = document.getElementById('hxBubs');
  var hsGift = document.getElementById('hsGift'), hsCard = document.getElementById('hsCard');
  var openGiftInfo = function () {
    if (giftKey === 'carmd') { document.dispatchEvent(new CustomEvent('carmd:window')); return; }
    var more = giftKey && document.querySelector('[data-gift-info="' + giftKey + '"]');
    if (more) more.click();
  };
  if (hsGift) hsGift.addEventListener('click', function (e) { e.stopPropagation(); openGiftInfo(); });
  if (hsCard) {
    var cardNote = function (on) { hsCard.classList.toggle('open', on); hsCard.setAttribute('aria-expanded', on ? 'true' : 'false'); };
    hsCard.addEventListener('click', function (e) { e.stopPropagation(); cardNote(!hsCard.classList.contains('open')); });
    document.addEventListener('click', function (e) { if (!hsCard.contains(e.target)) cardNote(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cardNote(false); });
  }

  /* ---------- the offer's words, values and gift ---------- */
  // from Nov 6 CarMD Connect is no gift (carmdOn): its card leaves the picker and the CarMD Connect section goes (.no-carmd)
  if (holiday && !GIFTS.carmd) {
    root.classList.add('no-carmd');
    var cmdPick = document.getElementById('pickCarmd'), cmdCard = cmdPick && cmdPick.closest('.pick');
    if (cmdCard) cmdCard.parentNode.removeChild(cmdCard);
    var picksRow0 = document.getElementById('picksRow');
    if (picksRow0) picksRow0.style.setProperty('--n', Object.keys(GIFTS).length);
  }
  var radios = [].slice.call(document.querySelectorAll('input[name="freeGift"]'));
  var cards = {}, imgFor = {};   // the picker photos double as the bundle-list and cart pictures (their src is Shopify-rewritten)
  radios.forEach(function (r) {
    cards[r.value] = r.closest('.pick');
    var im = r.parentNode.querySelector('label img'); if (im) imgFor[r.value] = im.getAttribute('src');
  });
  var giftRow = document.getElementById('giftRowName'); giftRow = giftRow && giftRow.closest('.srow');
  var ciGift = document.getElementById('ciGiftName'); ciGift = ciGift && ciGift.closest('.citem');
  var setGiftPics = function (key, name) {
    [['giftRowImg', ''], ['ciGiftImg', name]].forEach(function (p) {
      var im = document.getElementById(p[0]);
      if (im && imgFor[key]) { im.setAttribute('src', imgFor[key]); if (p[1]) im.setAttribute('alt', p[1]); }
    });
  };
  /* the words that follow the offer outside it: the top bar, the hero's price card and the floating bar.
     season: the season's name (or "Special offer"); free: what comes free besides the boot, the app and
     shipping ("CarMD Connect + $20 gift card"), or '' when nothing does; save: the bundle's saving. */
  var setLead = function (season, free, save, chipS, chipL) {
    setHTML('tbarChip', season);
    setHTML('tbarTxt', 'Save $' + save + (free ? ' · Free ' + free : ''));
    setHTML('hxPill', season.replace(/ Sale$/, '') + ' bundle');
    var inc = free ? 'Includes ' + free + ', free.' : '';
    // while the email price runs the hero's price says the rest, so its line keeps to what is included
    setHTML('hxSave', mailOpen && inc ? inc : 'You save $' + save + '.' + (inc ? ' ' + inc : ''));
    setHTML('fbChipS', chipS);
    setHTML('fbChipL', chipL);
  };
  // the hero's gift bubble opens the picked gift's window, as the offer photo's callout does
  var hxBubGift = document.getElementById('hxBubGift');
  if (hxBubGift) hxBubGift.addEventListener('click', openGiftInfo);
  /* the callout and the bubble name the picked gift (pick-n: "3360 Thermal Camera"), or hide with no gift */
  var giftMarks = function (key, shortName) {
    var g = key ? GIFTS[key] : null;
    var cs = CARD_SPOT[key] || CARD_SPOT.other;
    if (hsCard) {
      hsCard.style.setProperty('--x', cs[0] + '%');
      hsCard.style.setProperty('--y', cs[1] + '%');
      hsCard.classList.toggle('hs-left', !!cs[2]);
      hsCard.classList.toggle('hs-west', cs[0] < 50);   // on the photo's left half: on a small photo its note opens rightwards
    }
    // the hero bubbles change sides with the photo: the gift's under the dongles on the right, the card's on the left
    if (hxBubs) hxBubs.classList.toggle('is-flip', key === 'carmd');
    [hsGift, hxBubGift].forEach(function (el) { if (el) el.hidden = !g; });
    if (!g) return;
    var label = shortName + ', free with your 5610. See what it does';
    setHTML('hsGiftName', shortName); setHTML('hsGiftVal', '$' + g.value);
    setHTML('hxBubName', shortName); setHTML('hxBubSub', GIFT_SUBS[key]); setHTML('hxBubVal', '$' + g.value);
    if (hsGift) {
      hsGift.setAttribute('aria-label', label);
      hsGift.style.setProperty('--x', GIFT_SPOT[key][0] + '%');
      hsGift.style.setProperty('--y', GIFT_SPOT[key][1] + '%');
      hsGift.classList.toggle('hs-left', !!GIFT_SPOT[key][2]);
    }
    if (hxBubGift) hxBubGift.setAttribute('aria-label', label);
  };
  var setSums = function (value) {
    var save = value - price(), pct = Math.round(save / value * 100);
    setHTML('dealPill', 'Save ' + pct + '%');
    setHTML('dealValue', '$' + value + ' total value');
    setHTML('dealSave', 'You save $' + save + ' &rarr;');
    setHTML('cartSaveText', '$' + save + ' &middot; ' + pct + '% OFF');
    setHTML('cartRetail', '$' + value);
    setHTML('cartDiscount', '&minus;$' + save);
    var fill = function (sel, txt) { [].forEach.call(document.querySelectorAll(sel), function (el) { el.textContent = txt; }); };
    fill('.js-sum-value', '$' + value);
    fill('.js-sum-save', '$' + save);
    fill('.js-sum-gifts', '$' + (value - MSRP));
    fill('.js-price', '$' + price());
    fill('.js-off', offStr());
    return save;
  };
  var renderGift = function () {};
  var soldOut = {};

  if (holiday) {
    setHTML('dealBadge', holiday.badge);
    setHTML('picksTitle', holiday.pick);
    renderGift = function () {
      var g = giftKey ? GIFTS[giftKey] : null;   // null only when every gift is sold out
      [giftRow, ciGift].forEach(function (el) { if (el) el.hidden = !g; });
      if (g) {
        setHTML('giftRowName', g.name);
        setHTML('giftRowVal', '$' + g.value);
        setHTML('giftRowSub', GIFT_SUBS[giftKey]);
        setHTML('ciGiftName', g.cartName);
        setHTML('ciGiftSub', 'A $' + g.value + ' value, included free');
        setHTML('ciGiftWas', '$' + g.value);
        setGiftPics(giftKey, g.name);
      }
      radios.forEach(function (r) {
        r.checked = (r.value === giftKey);
        if (cards[r.value]) cards[r.value].classList.toggle('on', r.checked);
      });
      if (promo) setToggle();
      if (saleActive) { renderSale(); return; }   // the flash deal keeps the numbers, photos and links until the visitor switches back
      var save = setSums(MSRP + (g ? g.value : 0) + GIFT_CARD_VALUE + F_BOOT + F_APP + F_SHIP);
      var giftName = g && cards[giftKey] ? cards[giftKey].querySelector('.pick-n').textContent : '';
      giftMarks(g ? giftKey : null, giftName);
      giftPhotos(g ? giftKey : null);
      setLead(holiday.badge, (giftName ? giftName + ' + ' : '') + '$20 gift card', save,
        g ? 'GIFT + $20 CARD + ' + offStr() + ' OFF' : '$20 CARD + ' + offStr() + ' OFF',
        g ? 'FREE GIFT + $20 GIFT CARD + SAVE ' + offStr() : '$20 GIFT CARD + SAVE ' + offStr());
      setCheckout(bundleCart());
    };
    /* a sold-out gift is left out of the picker (the user, Oct 14 2026: "make sure the freebies will not be
       shown if it's out of stock"), and the picker's columns close up around the ones left */
    var markSoldOut = function (key, out) {
      soldOut[key] = out;
      var card = cards[key]; if (!card) return;
      card.classList.toggle('is-out', out);
      var r = card.querySelector('input'); if (r) r.disabled = out;
    };
    var choose = function (key) { if (!GIFTS[key] || soldOut[key]) return; giftKey = key; renderGift(); };
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) choose(r.value); }); });
    // "Make it my free gift", "Choose the 3380" and the like (the CarMD Connect section and the gift windows)
    document.querySelectorAll('[data-pick]').forEach(function (el) {
      el.addEventListener('click', function () { choose(el.getAttribute('data-pick')); });
    });
    renderGift();

    /* the stock check: a sold-out gift leaves the picker, and if it was the picked one the next gift in line
       is picked, so the photos, the callouts, the bundle list and the cart link all move to it. If all three
       are gone, the picker goes too and the bundle carries on with the gift card alone. */
    var keys = Object.keys(GIFTS), picksRow = document.getElementById('picksRow');
    checkStock(keys, function (avail) {
      var inStock = keys.filter(function (k) { return avail[k] !== false; });
      keys.forEach(function (k) { markSoldOut(k, avail[k] === false); });
      if (picksRow) { picksRow.style.setProperty('--n', inStock.length || 1); picksRow.classList.toggle('one', inStock.length === 1); }
      // the CarMD Connect section above the offer only belongs there while CarMD Connect can be picked
      root.classList.toggle('no-carmd', !GIFTS.carmd || avail.carmd === false);
      if (!inStock.length) {
        giftKey = null;
        if (picksBox) picksBox.classList.add('no-gifts');
        setHTML('picksCardTitle', 'A free $20 Innova gift card');
        renderGift();
        return;
      }
      if (inStock.length === 1) {                // one left: nothing to pick between
        setHTML('picksTitle', holiday.pick.replace(/: pick one$/, ''));
        setHTML('picksSub', 'It ships free with your 5610.');
      }
      // the next gift in the picker's order (Object.keys would list "3360" and "3380" before "carmd": number-like keys come
      // first), so on Black Friday a sold-out 3360 gives way to CarMD Connect, as it is the usual first pick
      if (avail[giftKey] === false) choose(['carmd', '3360', '3380'].filter(function (k) { return GIFTS[k] && avail[k] !== false; })[0]);
    });
  } else {
    /* the everyday offer: the 3360 as the gift; without it (every line about it left out, .no-camera) when
       Shopify says it is sold out. The hero photo shows the 3360, or no gift. (Its gift card stays in the
       photo: there is no version without one.) */
    var renderEveryday = function () {
      setHTML('dealBadge', 'Limited Time');
      setHTML('giftRowName', GIFTS['3360'].name);
      setHTML('giftRowVal', '$' + F_CAM);
      setHTML('giftRowSub', GIFT_SUBS['3360']);
      setHTML('ciGiftName', GIFTS['3360'].cartName);
      setHTML('ciGiftSub', 'A $' + F_CAM + ' value, included free');
      setHTML('ciGiftWas', '$' + F_CAM);
      setGiftPics('3360', GIFTS['3360'].name);
      if (promo) setToggle();
      if (saleActive) { renderSale(); return; }
      giftPhotos(noCamera ? null : '3360');
      var save = setSums(MSRP + (noCamera ? 0 : F_CAM) + F_BOOT + F_APP + F_SHIP);
      if (noCamera) setLead('Special offer', '', save, offStr() + ' OFF', 'SAVE ' + offStr());
      else setLead('Special offer', '3360 Thermal Camera', save, 'CAMERA + ' + offStr() + ' OFF', 'FREE $200 CAMERA + SAVE ' + offStr());
      setCheckout(bundleCart());
    };
    renderEveryday();
    checkStock(['3360'], function (avail) {
      if (avail['3360'] !== false) return;
      noCamera = true;
      root.classList.add('no-camera');
      renderEveryday();
    });
  }

  /* ---------- the email price's boxes (see MAIL_DEAL) ----------
     One in the hero, one above the offer's Claim Offer (the hero's asked for by the user's manager, Oct 26 2026). An
     email in either unlocks both, the page and every cart link. Klaviyo hears which box it came from (custom_source). */
  (function () {
    var boxes = [].slice.call(document.querySelectorAll('.dp-mail'));
    if (!boxes.length || !mailOpen) return;
    root.classList.add('mail-open');      // shows the locked price, hides the "off the scanner" line; the phone photo makes room
    var rerender = function () { if (holiday) renderGift(); else renderEveryday(); };
    var showDone = function () {
      boxes.forEach(function (b) { b.querySelector('.md-form').hidden = true; b.querySelector('.md-done').hidden = false; });
      root.classList.add('mail-on');
    };
    boxes.forEach(function (b) { b.hidden = false; });
    if (mailOn()) showDone();
    var valid = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };
    var subscribe = function (email, place) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(MAIL_DEAL.klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription',
          attributes: { custom_source: '5610 Bundle Page $299 Email Price (' + place + ')',
            profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { list: { data: { type: 'list', id: MAIL_DEAL.list } } } } })
      }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); return r; });
    };
    boxes.forEach(function (box) {
      var form = box.querySelector('.md-form'), input = box.querySelector('input[type="email"]'), err = box.querySelector('.md-err');
      var place = box.getAttribute('data-place') || 'offer';
      // "Email to unlock $299" is cut off in a field this narrow; the lock beside the price says it already
      if (window.matchMedia && matchMedia('(max-width: 379px)').matches) input.setAttribute('placeholder', 'Your email');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (input.value || '').trim();
        if (!valid(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; input.focus(); return; }
        err.hidden = true;
        var btn = form.querySelector('.md-go'), label = btn.textContent;
        btn.disabled = true; btn.textContent = 'One moment…';
        (mailEmail === 'preview' ? Promise.resolve() : subscribe(email, place)).then(function () {
          mailEmail = email;
          try { localStorage.setItem(MAIL_DEAL.store, email); } catch (er) {}
          showDone();
          rerender();          // $299 everywhere, and the code in every cart link
        }).catch(function () {
          btn.disabled = false; btn.textContent = label;
          err.textContent = 'Something went wrong. Please try again.'; err.hidden = false;
        });
      });
    });
  })();

  /* ---------- the flash sale (the user, Nov 2 2026: "it's not following the discount schedule") ----------
     The partnerships pages' schedule, read from the same published Google Sheet (Start (PST) | End (PST) | Price |
     3360 Camera). While a row's window is open (Pacific), the page leads with the flash deal: the 5610 at the sheet's
     price with the boot, the app and shipping free, and no gift (SALE_CART, the partnerships pages' sale link and
     codes). A switch at the top of the offer box goes to the gift bundle and back, as on the partnerships pages. The
     top bar counts down to the sale's end, and at that moment the page goes back to the gift bundle by itself. The
     sheet's 3360 Camera column is not read: every row says No, and the gift bundle is one tap away.
     Preview: ?sale=preview (a $269 sale with no end), ?sale=off (the sheet is not asked). */
  var SALE_SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR8_-VBtZsinlLkdfa5JdAKT7_27Y0l839zMT_yXsD5qtTwCpcxBcQN0yfgjeZ_Hg5opfnYmNfFUDrb/pub?output=csv';
  var SALE_CART = 'https://www.innova.com/cart/' + BUNDLE_ITEMS + '?discount=5610_PARTNERSHIP,5610_PARTNERSHIPS_FP';
  var dealToggle = document.getElementById('dealToggle'), cdBox = document.querySelector('.tbar-cd'), mailKept = [];
  var setAll = function (sel, html) { [].forEach.call(document.querySelectorAll(sel), function (el) { el.innerHTML = html; }); };
  var renderSale = function () {
    var off = '$' + (MSRP - promo.price);
    var save = setSums(MSRP + F_BOOT + F_APP + F_SHIP);
    setHTML('dealBadge', 'Flash sale');
    setAll('.js-gifts-word', 'in free extras');
    giftPhotos('flash');
    setHTML('tbarChip', 'Flash sale');
    setHTML('tbarTxt', 'Now just $' + promo.price + ' · ' + off + ' off the 5610');
    setHTML('hxPill', 'Flash sale');
    setHTML('hxSave', 'You save $' + save + '. Includes the boot, the app and shipping, free.');
    setHTML('fbChipS', 'FLASH SALE · ' + off + ' OFF');
    setHTML('fbChipL', 'FLASH SALE · SAVE ' + off + ' · NOW $' + promo.price);
    setCheckout(SALE_CART);
  };
  // the switch's two sides: the flash price, and the gift bundle as it stands (the picked gift, or the everyday 3360)
  var setToggle = function () {
    if (!dealToggle) return;
    dealToggle.hidden = !promo || (!holiday && noCamera);   // the everyday bundle without its camera would only cost more
    if (promo) setHTML('dtSale', 'Just $' + promo.price + ' &middot; best price');
    var bp = '$' + (dropOn ? PRICE_DROP.price : mailOpen && mailEmail ? MAIL_DEAL.price : BUNDLE_PRICE);
    setHTML('dtBundle', holiday ? bp + (giftKey ? ' + free gift + $20 card' : ' + $20 gift card') : bp + ' + free 3360 camera');
    [].forEach.call(dealToggle.querySelectorAll('[data-offer]'), function (b) {
      var on = (b.getAttribute('data-offer') === 'sale') === saleActive;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (cdBox) cdBox.setAttribute('aria-label', saleActive && promo && promo.end ? 'Flash sale ends in' : 'Offer ends at midnight');
  };
  var applySale = function () {
    saleActive = true;
    mailKept = ['mail-open', 'mail-on'].filter(function (c) { return root.classList.contains(c); });
    mailKept.forEach(function (c) { root.classList.remove(c); });
    root.classList.add('sale-mode');          // hides the gift, the gift card, the callouts, the bubbles and the installments line
    renderSale();
    setToggle();
  };
  var applyNormal = function () {
    saleActive = false;
    root.classList.remove('sale-mode');
    mailKept.forEach(function (c) { root.classList.add(c); });
    mailKept = [];
    setAll('.js-gifts-word', 'in free gifts');
    if (holiday) { setHTML('dealBadge', holiday.badge); renderGift(); } else renderEveryday();
    setToggle();
  };
  // the sale's end has come (the countdown checks every second): back to the gift bundle, and the switch goes
  var endFlash = function () {
    var was = saleActive;
    promo = null;
    if (was) applyNormal(); else setToggle();
  };
  var activateSale = function (cfg) {
    promo = cfg;
    /* The CarMD Connect section above the offer stands down for this visit while the flash deal leads (.flash-lead), as on
       the partnerships pages. Only while the visitor is still near the top, though: the sheet answers a moment after
       load, and taking a section out from above someone who has scrolled would jump the page under them. */
    var scrolled = Math.max(window.pageYOffset || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0);
    if (scrolled < 400) root.classList.add('flash-lead');
    root.classList.add('flash-run');          // the phone photo makes room for the switch, and keeps it
    applySale();
  };
  if (dealToggle) [].forEach.call(dealToggle.querySelectorAll('[data-offer]'), function (b) {
    b.addEventListener('click', function () {
      if (!promo) return;
      if (b.getAttribute('data-offer') === 'sale') { if (!saleActive) applySale(); }
      else if (saleActive) applyNormal();
    });
  });
  // a button that picks a gift (the gift windows', the CarMD Connect section's) asks for the gift bundle
  [].forEach.call(document.querySelectorAll('[data-pick],[data-offer-go="camera"]'), function (el) {
    el.addEventListener('click', function () { if (saleActive) applyNormal(); });
  });

  // whatever Google Sheets exports, as a zero-padded "YYYY-MM-DD HH:MM", so the times compare as strings
  var toKey = function (s) {
    s = (s || '').trim(); if (!s) return '';
    var dm = s.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/) || s.match(/(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
    if (!dm) return '';
    var y, mo, d;
    if (dm[1].length === 4) { y = dm[1]; mo = dm[2]; d = dm[3]; } else { mo = dm[1]; d = dm[2]; y = dm[3]; }
    var hh = 0, mm = 0, tm = s.match(/(\d{1,2}):(\d{2})\s*([ap]m)?/i);
    if (tm) {
      hh = parseInt(tm[1], 10); mm = parseInt(tm[2], 10);
      var ap = (tm[3] || '').toLowerCase();
      if (ap === 'pm' && hh < 12) hh += 12;
      if (ap === 'am' && hh === 12) hh = 0;
    }
    var p = function (n, w) { n = String(parseInt(n, 10) || 0); while (n.length < w) n = '0' + n; return n; };
    return p(y, 4) + '-' + p(mo, 2) + '-' + p(d, 2) + ' ' + p(hh, 2) + ':' + p(mm, 2);
  };
  // a Pacific "YYYY-MM-DD HH:MM" as a moment (ms): Pacific is 7 or 8 hours behind UTC, whichever reads back the same
  var pacificMs = function (key) {
    var m = key.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/);
    if (!m) return 0;
    var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    for (var h = 7; h <= 8; h++) if (pacificNow(utc + h * 3600000) === key) return utc + h * 3600000;
    return utc + 8 * 3600000;
  };
  var parseCSV = function (text) {
    var lines = text.split(/\r?\n/).filter(function (l) { return l.trim(); });
    if (lines.length < 2) return [];
    var head = lines[0].split(',').map(function (h) { return h.trim().toLowerCase().replace(/^"|"$/g, ''); });
    var find = function (name) { for (var i = 0; i < head.length; i++) if (head[i].indexOf(name) === 0) return i; return -1; };
    var iS = find('start'), iE = find('end'), iP = find('price'), rows = [];
    for (var k = 1; k < lines.length; k++) {
      var c = lines[k].split(',').map(function (v) { return v.trim().replace(/^"|"$/g, ''); });
      rows.push({ start: c[iS], end: c[iE], price: iP >= 0 ? c[iP] : '' });
    }
    return rows;
  };
  var checkSale = function (rows) {
    var now = pacificNow(); if (!now) return;
    for (var i = 0; i < rows.length; i++) {
      var start = toKey(rows[i].start), end = toKey(rows[i].end);
      if (start && end && start <= now && now < end) {
        activateSale({ price: parseInt(rows[i].price, 10) || 269, end: pacificMs(end) });
        return;
      }
    }
  };
  if (/[?&]sale=preview\b/.test(location.search)) activateSale({ price: 269, end: 0 });
  else if (!/[?&]sale=off\b/.test(location.search) && window.fetch) {
    fetch(SALE_SHEET_URL + '&_cb=' + Math.floor(Date.now() / 60000))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { if (t) checkSale(parseCSV(t)); })
      .catch(function () { /* the sheet can't be reached: the page stays as it is */ });
  }

  /* ---------- scarcity: live stock counter ---------- */
  var stockLeft = document.getElementById('stockLeft'), scarFill = document.getElementById('scarFill');
  if (stockLeft && scarFill) {
    var pct = 4; // % of the bundle left
    var renderStock = function () { stockLeft.textContent = pct + '%'; scarFill.style.width = pct + '%'; };
    renderStock();
    setInterval(function () {
      if (pct > 2 && Math.random() < 0.55) { pct = Math.max(2, Math.round((pct - (Math.random() * 0.3 + 0.1)) * 10) / 10); renderStock(); }
    }, 8000);
  }

  /* ---------- the partnerships windows: supported features and the three gifts ----------
     Their videos play while they are open and stop when they close. */
  var playAll = function (box) { box.querySelectorAll('video').forEach(playSafe); };
  var stopAll = function (box) { box.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); }); };
  var giftWindow = function (id, openers) {
    var box = document.getElementById(id);
    if (box) wireWindow(box, openers, '[data-close]', function () { playAll(box); }, function () { stopAll(box); });
  };
  giftWindow('featModal', document.querySelectorAll('.js-feat-open'));
  giftWindow('cam3360Modal', [document.getElementById('cam3360Open'), document.querySelector('[data-gift-info="3360"]')].filter(Boolean));
  giftWindow('gift3380Modal', document.querySelectorAll('[data-gift-info="3380"]'));
  giftWindow('giftCarmdModal', document.querySelectorAll('[data-gift-info="carmd"]'));

  /* ---------- accordions (offer box + FAQ) ---------- */
  function accordion(box) {
    if (!box) return;
    box.querySelectorAll('.it').forEach(function (item) {
      var q = item.querySelector('.q'), a = item.querySelector('.a');
      q.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      if (item.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        box.querySelectorAll('.it.open').forEach(function (o) {
          o.classList.remove('open');
          o.querySelector('.a').style.maxHeight = null;
          o.querySelector('.q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
          // a picture inside can finish loading after the panel opened; give it the room
          [].forEach.call(a.querySelectorAll('img'), function (im) {
            if (!im.complete) im.addEventListener('load', function () { if (item.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px'; }, { once: true });
          });
        }
      });
    });
  }
  accordion(document.getElementById('acc'));
  accordion(document.getElementById('faq'));

  /* ---------- delivery date: 2 days ahead (Pacific) ---------- */
  var deliveryEl = document.getElementById('deliveryDate');
  if (deliveryEl) {
    try {
      deliveryEl.textContent = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles', weekday: 'long', month: 'long', day: 'numeric'
      }).format(new Date(Date.now() + 2 * 86400000));
    } catch (e) { /* leave the fallback text */ }
  }

  /* ---------- slide-in cart: the offer's buttons open it; the others go to the offer ---------- */
  var cartDrawer = document.getElementById('cartDrawer');
  if (cartDrawer) {
    /* 5-minute "cart reserved" countdown: starts on first open, persists across opens */
    var cartTimerEl = document.getElementById('cartTimer');
    var cartEnd = 0, cartInt = null, pad2 = function (n) { return String(n).padStart(2, '0'); };
    var renderCartTimer = function () {
      if (!cartTimerEl) return;
      var d = Math.max(0, cartEnd - Date.now());
      cartTimerEl.textContent = Math.floor(d / 60000) + ':' + pad2(Math.floor((d % 60000) / 1000));
      if (d <= 0 && cartInt) { clearInterval(cartInt); cartInt = null; }
    };
    var startCartTimer = function () {
      var now = Date.now();
      if (!cartEnd || cartEnd - now <= 0) cartEnd = now + 5 * 60 * 1000;
      renderCartTimer();
      if (!cartInt) cartInt = setInterval(renderCartTimer, 1000);
    };
    var openCart = function () {
      cartDrawer.classList.add('open');       // display:block
      void cartDrawer.offsetWidth;            // reflow so the transition runs from the off-screen state
      cartDrawer.classList.add('show');       // slide in + fade overlay
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      startCartTimer();
    };
    var closeCart = function () {
      cartDrawer.classList.remove('show');
      cartDrawer.setAttribute('aria-hidden', 'true');
      setTimeout(function () {
        if (!cartDrawer.classList.contains('show')) cartDrawer.classList.remove('open');
        if (!anyOpen()) document.body.classList.remove('modal-lock');
      }, 440);
    };
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('open')) closeCart();
    });

    var scrollToBuy = function () {
      var buy = document.getElementById('buy');
      // scrollIntoView scrolls whatever the real container is (window.scrollTo no-ops on Shopify,
      // where the theme makes <body> the scroller). The floating bar's room is CSS scroll-margin-top.
      if (buy && buy.scrollIntoView) buy.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
    };
    /* Fire a CTA-click event into whatever analytics the store has (Meta Pixel, GA4, GTM dataLayer).
       page: 'offer' tells these clicks apart from the partnerships pages' (same event name). No-op on Railway. */
    var trackCTA = function (el) {
      var label = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var where = el.closest('#buy') ? 'offer'
                : el.closest('.hx') ? 'hero'
                : el.closest('.fbar') ? 'floating-bar'
                : el.closest('.guar') ? 'guarantee'
                : el.closest('.modal') ? 'modal'
                : el.closest('.cmd') ? 'carmd' : 'other';
      var data = { button_text: label, location: where, product: '5610', page: 'offer' };
      try { if (window.fbq) fbq('trackCustom', 'ClaimOfferClick', data); } catch (e) {}
      try { if (window.gtag) gtag('event', 'claim_offer_click', data); } catch (e) {}
      try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'claim_offer_click', button_text: label, location: where, product: '5610', page: 'offer' }); } catch (e) {}
    };
    /* A button outside the offer goes to the offer. While the offer's own buy button is on screen that
       would do nothing, so it opens the cart instead. */
    var firstBuy = document.querySelector('#buy .claim-first');
    var onScreen = function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    };
    document.querySelectorAll('.js-checkout').forEach(function (el) {
      var inOffer = !!el.closest('#buy');
      el.addEventListener('click', function (e) {
        e.preventDefault();
        trackCTA(el);
        if (inOffer || (firstBuy && onScreen(firstBuy))) openCart();
        else scrollToBuy();
      });
    });
  }

  /* ==========================================================
     CARMD CONNECT SECTION (above the offer) and THE CARMD WINDOW, as on the switch page (script-switch.js)
     The feature list and the photo are one control: the lit feature names the callout on the photo. It
     moves on by itself every few seconds until the visitor picks a feature, waits while the section is off
     screen or the list is under the pointer, and stays put under prefers-reduced-motion. The photo leans
     toward a mouse pointer (never on touch). The same code drives the section and its copy in the window.
     ========================================================== */
  function cmdRun(sec) {
    var feats = [].slice.call(sec.querySelectorAll('.cmd-f'));
    var list = sec.querySelector('.cmd-list'), stage = sec.querySelector('.cmd-stage');
    var call = sec.querySelector('.cmd-call'), callK = sec.querySelector('.cmd-call-k'), callT = sec.querySelector('.cmd-call-t');
    var link = sec.querySelector('.cmd-link');
    if (!feats.length) return;
    var STEP = 5200;                 // keep in step with cmdProg in style-offer.css
    var cur = 0, auto = !still, onScreen = false, hovering = false, timer = 0;
    function plan() {
      clearTimeout(timer);
      var run = auto && onScreen && !hovering && !document.hidden;
      sec.classList.toggle('is-auto', run);
      if (run) timer = setTimeout(function () { show(cur + 1, false); }, STEP);
    }
    function show(i, byHand) {
      cur = (i + feats.length) % feats.length;
      feats.forEach(function (b, k) {
        b.classList.toggle('on', k === cur);
        b.setAttribute('aria-pressed', k === cur ? 'true' : 'false');
      });
      if (call && callK && callT) {
        call.classList.remove('swap');
        void call.offsetWidth;                                   // restart the swap-in animation
        callK.textContent = feats[cur].getAttribute('data-k');
        callT.textContent = feats[cur].getAttribute('data-t');
        call.classList.add('swap');
      }
      if (byHand) auto = false;                                  // a deliberate pick ends the slideshow
      plan();
    }
    feats.forEach(function (b, k) { b.addEventListener('click', function () { show(k, true); }); });
    if (list) {
      list.addEventListener('mouseenter', function () { hovering = true; plan(); });
      list.addEventListener('mouseleave', function () { hovering = false; plan(); });
    }
    document.addEventListener('visibilitychange', plan);
    function setOnScreen(v) {
      onScreen = v;
      sec.classList.toggle('is-idle', !v);
      try { if (link && link.pauseAnimations) { if (v && !still) link.unpauseAnimations(); else link.pauseAnimations(); } } catch (e) {}
      plan();
    }
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (en) { en.forEach(function (x) { setOnScreen(x.isIntersecting); }); }, { threshold: 0.2 }).observe(sec);
    } else { setOnScreen(true); }
    var fine = false;
    try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}
    var tilt = stage && stage.querySelector('.cmd-tilt');
    if (tilt && fine && !still) {
      var raf = 0, px = 0, py = 0;
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        if (!r.width) return;
        px = (e.clientX - r.left) / r.width - 0.5;
        py = (e.clientY - r.top) / r.height - 0.5;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          tilt.style.setProperty('--ry', (px * 9).toFixed(2) + 'deg');
          tilt.style.setProperty('--rx', (-py * 9).toFixed(2) + 'deg');
          tilt.style.setProperty('--gx', ((px + 0.5) * 100).toFixed(1) + '%');
          tilt.style.setProperty('--gy', ((py + 0.5) * 100).toFixed(1) + '%');
        });
      });
      stage.addEventListener('pointerleave', function () {
        tilt.style.setProperty('--ry', '0deg');
        tilt.style.setProperty('--rx', '0deg');
      });
    }
  }
  var carmdSec = document.getElementById('carmd');
  if (carmdSec) cmdRun(carmdSec);

  /* the CarMD window, opened by the CarMD Connect callout on the offer photo. The first time, it copies the
     section's grid in (ids removed) and starts the same animation on the copy. Its button closes the window
     and brings the buy button into view, since CarMD Connect is already the gift when it can be opened. */
  (function () {
    var modal = document.getElementById('carmdModal');
    if (!modal || !carmdSec) return;
    var sheet = modal.querySelector('.cmd-sheet'), built = false, back = null;
    var close = function () {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      if (!anyOpen()) document.body.classList.remove('modal-lock');
      if (back && back.focus) back.focus();
    };
    var open = function () {
      if (!built) {
        var copy = carmdSec.querySelector('.cmd-grid').cloneNode(true);
        [].forEach.call(copy.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
        var cta = copy.querySelector('.cmd-cta');
        if (cta) {
          cta.classList.remove('js-checkout');
          cta.addEventListener('click', function (e) {
            e.preventDefault();
            close();
            var buy = document.querySelector('#buy .claim-first');
            if (buy && buy.scrollIntoView) buy.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' });
          });
        }
        sheet.appendChild(copy);
        cmdRun(sheet);
        built = true;
      }
      back = document.activeElement;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      var x = modal.querySelector('.cmd-x'); if (x) x.focus();
    };
    document.addEventListener('carmd:window', open);
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
  })();

  /* ---------- "The technical side", a row of function cards scrolled sideways (as on the switch page) ----------
     The browser's own scrolling does the work (touch, trackpad, keyboard). This adds the arrows, the
     position bar and the count, and lets a mouse drag the row. */
  (function () {
    var rail = document.getElementById('techRail');
    if (!rail) return;
    var cardsT = rail.querySelectorAll('.tc');
    var feats = rail.querySelectorAll('.tc:not(.tc-more)').length;      // the last card is the link to the full list
    var prev = document.getElementById('techPrev'), next = document.getElementById('techNext');
    var bar = document.getElementById('techBar'), now = document.getElementById('techNow'), all = document.getElementById('techAll');
    var two = function (n) { return (n < 10 ? '0' : '') + n; };
    var step = function () { return cardsT.length > 1 ? cardsT[1].offsetLeft - cardsT[0].offsetLeft : rail.clientWidth; };
    if (all) all.textContent = two(feats);
    var raf = 0;
    var update = function () {
      raf = 0;
      var x = rail.scrollLeft, max = rail.scrollWidth - rail.clientWidth, s = step();
      if (bar) {
        bar.style.setProperty('--tw', (rail.clientWidth / rail.scrollWidth).toFixed(4));
        bar.style.setProperty('--tp', (x / rail.scrollWidth).toFixed(4));
      }
      if (prev) prev.disabled = x < 4;
      if (next) next.disabled = x > max - 4;
      rail.classList.toggle('at-end', x > max - 4);
      if (now) {      // the cards in view, as "01-04" (or just "01" when a phone shows one at a time)
        var first = Math.min(feats, Math.round(x / s) + 1);
        var last = Math.min(feats, Math.max(first, Math.floor((x + rail.clientWidth - 24) / s)));
        now.textContent = last > first ? two(first) + '-' + two(last) : two(first);
      }
    };
    var queue = function () { if (!raf) raf = requestAnimationFrame(update); };
    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    var go = function (dir) {      // a screenful of cards at a time
      var s = step(), n = Math.max(1, Math.floor(rail.clientWidth / s));
      rail.scrollBy({ left: dir * n * s, behavior: still ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var down = false, dragged = false, startX = 0, startLeft = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; dragged = false; startX = e.clientX; startLeft = rail.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) < 5) return;
      dragged = true;
      rail.classList.add('is-drag');
      rail.scrollLeft = startLeft - dx;
    });
    var release = function () { if (down) { down = false; rail.classList.remove('is-drag'); } };
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    // letting go after a drag must not count as a click on the button in the last card
    rail.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
    update();
  })();

  /* ---------- anchor scrolling ---------- */
  document.querySelectorAll('a[href^="#"]:not(.js-checkout)').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      if (el.scrollIntoView) el.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---------- come back to this tab: alert the title + favicon when the visitor leaves ---------- */
  (function () {
    var origTitle = document.title;
    var favEl = document.querySelector('link[rel~="icon"]');
    if (!favEl) { favEl = document.createElement('link'); favEl.rel = 'icon'; document.head.appendChild(favEl); }
    // On Shopify the section's <link rel="icon"> renders inside <body>, where browsers ignore it: move it to <head>
    else if (!favEl.closest('head')) { document.head.appendChild(favEl); }
    var origHref = favEl.getAttribute('href');
    var badgedHref = null;
    var img = new Image();
    img.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = 32; c.height = 32;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, 32, 32);
        ctx.beginPath(); ctx.arc(23, 9, 8, 0, 2 * Math.PI);
        ctx.fillStyle = '#da291c'; ctx.fill();
        ctx.lineWidth = 2.5; ctx.strokeStyle = '#fff'; ctx.stroke();
        badgedHref = c.toDataURL('image/png');
      } catch (e) { /* canvas blocked, the title alert still works */ }
    };
    if (origHref) img.src = origHref;
    var ALERTS = ['🔴 Your deal is waiting', '👋 Come back for $200 OFF'];
    var flip = null, i = 0;
    var setFav = function (h) { if (h) favEl.setAttribute('href', h); };
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        setFav(badgedHref);
        i = 0; document.title = ALERTS[0];
        if (!flip) flip = setInterval(function () {
          i = (i + 1) % (ALERTS.length + 1);
          document.title = i === 0 ? origTitle : ALERTS[i - 1];
        }, 1400);
      } else {
        if (flip) { clearInterval(flip); flip = null; }
        document.title = origTitle;
        setFav(origHref);
      }
    });
  })();

  /* ---------- photo viewer: the offer's photos full size, with zoom ----------
     A click (or tap) on the photo, or on the button in its corner, opens it at the photo on show. The
     arrows, the thumbnails, a swipe or the arrow keys move between photos; Esc, the x or a click beside
     the photo closes it. A click on the photo zooms in at that spot: then the mouse looks around by
     moving (a finger by dragging), and another click zooms back out. The zoom goes as far as the photo's
     own pixels allow, between 2x and 3x. */
  (function () {
    var box = document.getElementById('lightbox'), main = document.getElementById('galMain');
    if (!box || !main) return;
    var frame = main.parentNode, stage = document.getElementById('lbxStage'), img = document.getElementById('lbxImg');
    var count = document.getElementById('lbxCount'), hint = document.getElementById('lbxHint'), strip = document.getElementById('lbxThumbs');
    var srcs = [].map.call(document.querySelectorAll('#galThumbs button'), function (b) { return b.getAttribute('data-src'); });
    if (!srcs.length) return;
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var words = { idle: touch ? 'Tap to zoom, swipe for more' : 'Click to zoom',
                  zoomed: touch ? 'Drag to look around, tap to zoom out' : 'Move to look around, click to zoom out' };
    var at = 0, zoomed = false, Z = 2, ox = 0.5, oy = 0.5, lastFocus = null, down = null, skipUntil = 0;
    var clamp = function (v) { return isFinite(v) ? Math.max(0, Math.min(1, v)) : 0.5; };
    var origin = function (x, y) { ox = x; oy = y; img.style.transformOrigin = (x * 100).toFixed(2) + '% ' + (y * 100).toFixed(2) + '%'; };
    var zoom = function (on, x, y) {
      if (on && !img.offsetWidth) return;             // the photo is still loading
      zoomed = on;
      box.classList.toggle('zoomed', on);
      if (on) {
        Z = Math.min(3, Math.max(2, (img.naturalWidth || 1000) / img.offsetWidth));
        origin(x, y);
        img.style.transform = 'scale(' + Z.toFixed(3) + ')';
      } else img.style.transform = '';
      hint.textContent = on ? words.zoomed : words.idle;
    };
    var show = function (n) {
      at = (n + srcs.length) % srcs.length;
      zoom(false);
      var want = srcs[at], next = new Image();
      next.onload = next.onerror = function () { if (srcs[at] === want) img.src = want; };
      next.src = want;
      img.alt = 'Innova 5610, photo ' + (at + 1) + ' of ' + srcs.length;
      count.textContent = (at + 1) + ' / ' + srcs.length;
      [].forEach.call(strip.children, function (b, k) { b.classList.toggle('on', k === at); });
      [at + 1, at - 1].forEach(function (k) { var p = new Image(); p.src = srcs[(k + srcs.length) % srcs.length]; });
    };
    srcs.forEach(function (src, n) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (n + 1));
      var t = document.createElement('img'); t.src = src; t.alt = '';
      b.appendChild(t);
      b.addEventListener('click', function () { show(n); });
      strip.appendChild(b);
    });
    var open = function () {
      // the first photo follows the picked gift, so read the photos afresh each time
      srcs = [].map.call(document.querySelectorAll('#galThumbs button'), function (b) { return b.getAttribute('data-src'); });
      [].forEach.call(strip.children, function (b, k) { var t = b.querySelector('img'); if (t && srcs[k] && t.getAttribute('src') !== srcs[k]) t.src = srcs[k]; });
      var n = srcs.indexOf(main.getAttribute('src'));
      lastFocus = document.activeElement;
      box.classList.add('open');
      box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      show(n < 0 ? 0 : n);
      box.querySelector('.lbx-x').focus();
    };
    var close = function () {
      box.classList.remove('open');
      box.setAttribute('aria-hidden', 'true');
      zoom(false);
      if (!anyOpen()) document.body.classList.remove('modal-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    frame.addEventListener('click', open);
    box.querySelectorAll('[data-lbx-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.getElementById('lbxPrev').addEventListener('click', function () { show(at - 1); });
    document.getElementById('lbxNext').addEventListener('click', function () { show(at + 1); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(at + 1);
      else if (e.key === 'ArrowLeft') show(at - 1);
    });
    // the page behind must not scroll while the viewer is open
    box.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
    box.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    stage.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY, ox: ox, oy: oy, type: e.pointerType, moved: false };
    });
    stage.addEventListener('pointermove', function (e) {
      if (zoomed && e.pointerType === 'mouse') {      // a mouse looks around just by moving
        var sr = stage.getBoundingClientRect();
        origin(clamp((e.clientX - sr.left - img.offsetLeft) / img.offsetWidth), clamp((e.clientY - sr.top - img.offsetTop) / img.offsetHeight));
        return;
      }
      if (!down || down.type === 'mouse') return;
      var dx = e.clientX - down.x, dy = e.clientY - down.y;
      if (Math.abs(dx) + Math.abs(dy) > 8) down.moved = true;
      if (zoomed) origin(clamp(down.ox - dx / ((Z - 1) * img.offsetWidth)), clamp(down.oy - dy / ((Z - 1) * img.offsetHeight)));
    });
    stage.addEventListener('pointerup', function (e) {
      var d = down; down = null;
      if (!d || d.type === 'mouse') return;
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (!zoomed && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(at + (dx < 0 ? 1 : -1));   // a swipe
      if (d.moved || Math.abs(dx) + Math.abs(dy) > 8) skipUntil = Date.now() + 300;   // a click right after is part of the gesture
    });
    stage.addEventListener('pointercancel', function () { down = null; });
    stage.addEventListener('click', function (e) {
      if (Date.now() < skipUntil) return;
      if (e.target !== img) { close(); return; }      // beside the photo
      if (zoomed) { zoom(false); return; }
      var r = img.getBoundingClientRect();
      zoom(true, clamp((e.clientX - r.left) / r.width), clamp((e.clientY - r.top) / r.height));
    });
    hint.textContent = words.idle;
  })();
})();
